import React from 'react';

import { Layout, Menu } from 'antd';
import { Colors } from 'enums/Colors';
import { log } from 'console';
import { fetchStorageFile } from 'hooks/StoreFiles';

type SiderEbookProps = {
    key: number;
    label: string;
    children?: { key: number; label: string }[];
};

const { Header, Content, Footer, Sider } = Layout;

interface ISiderEbookProps {
    // Define any props if needed
    dados: SiderEbookProps[];
    navActive: number;
    handleClick: (divRef: any, abaAcitve: number) => void;
    refs: React.RefObject<HTMLDivElement>[];
    logoEbook: string;
}

const SiderEbook: React.FC<ISiderEbookProps> = ({ dados, navActive, handleClick, logoEbook, refs }) => {
    return (
        <Sider
            style={{ backgroundColor: Colors.White }}
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={broken => {
                console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
                console.log(collapsed, type);
            }}
        >
            <div className="demo-logo-vertical">
                
                <img style={{ width: '100%', borderRight: '1px solid #f0f0f0', backgroundColor: Colors.Blue, padding: "20px", borderRadius: "0px" }} src={fetchStorageFile('anexo_storage_files_17225660729893967470.png_2025-11-21-1763746381553.png')} alt="Logo do Ebook" />
            </div>
            <Menu
                theme="light"
                mode="inline"
                selectedKeys={[navActive.toString()]}
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['6']}
                items={dados.map(item => ({
                    ...item,
                    onClick: e => {
                        if (item.key === 6) {
                            handleClick(refs[parseInt(e.key) - 1], parseInt(e.key));
                        } else {
                            handleClick(refs[item.key - 1], item.key);
                        }
                    },
                }))}
            />
        </Sider>
    );
};

export default SiderEbook;
